module.exports = __webpack_public_path__ + "img/malaga.fe45f181.jpg";